export default __webpack_public_path__ + "public/images/errors/broken-image-480.png?5288c89f";